import { useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import priceList from "@/data/services/branding/price-list.json";
import infoData from "@/data/services/branding/manual-branding/manual-branding.json";
import faq from "@/data/services/branding/manual-branding/faq.json";
import PageSEO from "@/components/common/PageSEO";
import PriceList from "@/components/service/components/price-list/PriceList";
import Faq from "@/components/contact/faq/Faq";
import Intro from "@/components/service/components/intro/Intro";
import Inclusives from "@/components/service/components/inclusives/Inclusives";
import Benefits from "@/components/service/components/benefits/Benefits";
import VisualBenefits from "@/components/service/components/visual-benefits/VisualBenefits";
import SimpleBanner from "@/components/service/components/simple-banner/SimpleBanner";

const ManualBranding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const ref = useRef<HTMLDivElement>(null);

  const scrollToRef = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <PageSEO section="services" keyName="manual-branding" />
      <Intro data={infoData} />
      <Inclusives hideDecor={true} data={infoData} />
      <Container style={{ height: "100%" }}>
        <SimpleBanner img={infoData.banner} />
      </Container>
      <VisualBenefits onClick={scrollToRef} data={infoData} />
      <Benefits data={infoData} />
      <Container style={{ height: "100%" }}>
        <div ref={ref}>
          <PriceList data={priceList} />
        </div>
        <Faq data={faq} />
      </Container>
    </>
  );
};

export default ManualBranding;
